export default {
  getQRCode: '/courierClient/getQRCodeUrlAndCUIDCode',
  queryCourierSurplusCount: '/v3/get/surplus/assign/count'
}
